import React from 'react';
import { ShieldCheck, Zap, Trash2 } from 'lucide-react';
const FEATURES = [
  {
    icon: <Zap className="h-8 w-8 text-yellow-500" />,
    title: "Inbox dùng một lần tức thì",
    description: "Tạo một địa chỉ email mới chỉ trong vài giây mà không cần đăng ký. Hoàn hảo cho các lần đăng ký một lần.",
    tag: "Inbox catch-all"
  },
  {
    icon: <ShieldCheck className="h-8 w-8 text-primary" />,
    title: "Bảo vệ quyền riêng tư hàng đầu",
    description: "Luôn ẩn danh và bảo vệ danh tính thực sự của bạn. Chúng tôi không theo dõi hoạt động của bạn.",
    tag: "Inbox tự do"
  },
  {
    icon: <Trash2 className="h-8 w-8 text-destructive" />,
    title: "Email tự hủy",
    description: "Tất cả email và hộp thư sẽ tự động bị xóa sau một khoảng thời gian, không để lại dấu vết kỹ thuật số.",
    tag: "Inbox tự hủy"
  }
];
export function InfoSection() {
  return (
    <section className="py-20">
      <div className="text-center mb-16">
        <h2 className="text-3xl md:text-4xl font-bold mb-4 uppercase tracking-widest">CỰC KỲ ĐƠN GIẢN</h2>
        <p className="text-muted-foreground max-w-2xl mx-auto">
          Khi địa chỉ email của bạn quá quý giá để chia sẻ với bất kỳ ai, CloudTempMail sẵn sàng giúp bạn luôn sạch sẽ và an toàn.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {FEATURES.map((feature, idx) => (
          <div
            key={idx}
            className="group glass-card p-8 rounded-2xl hover:border-primary/30 transition-all duration-300"
          >
            <div className="mb-6 p-3 bg-white/5 inline-block rounded-xl group-hover:scale-110 transition-transform">
              {feature.icon}
            </div>
            <div className="inline-block px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider bg-white/10 text-muted-foreground mb-4">
              {feature.tag}
            </div>
            <h3 className="text-xl font-bold mb-3">{feature.title}</h3>
            <p className="text-muted-foreground leading-relaxed">
              {feature.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}